import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PriceListTableProvider } from '../price-list-table/price-list-table';

@Injectable()
export class ConfigApiServiceProvider {
  host: any;
  project_config: any;
  dev_project_config: any;
  pricelistMaster: any;
  msaMaster: any;
  sowMaster: any;
  msaId: any = '';
  msaVersion: any = '';
  sowId: any = '';
  sowVersion: any = '';
  sowListMaster: any;
  constructor(public http: HttpClient, public pricelistService: PriceListTableProvider) {
    this.host = 'https://prodcast.cloud:3780/EPC_V4.svc';
    this.dev_project_config = 'https://drive.prodcast.cloud:3784';
    this.project_config = 'https:///drive.prodcast.cloud:3784';
  }

  getContractList(data: any): Observable<any> {
    return this.http.post(`${this.host}/summary/`, data);
  }

  saveContract(params: any): Observable<any> {
    return this.http.post(`${this.host}/postadd/`, params);
  }

  getClientSummaryAPi(url: any, data: any): Observable<any> {
    return this.http.post(`${url}`, data);
  }

    /////////////
  /* * * * * *
  *Download File
  * * * * * */
  async downloadFile(fileName,cbck) {
    var xhr = new XMLHttpRequest();
    var reponse = "";
    var url = this.project_config + '/download';
    xhr.open('POST', url, true);
    // xhr.responseType ='blob'
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onload = function (e) {
      reponse = xhr.responseText;
      cbck(reponse);
    };
    xhr.onreadystatechange = function (aEvt) {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
        }
      }
    };
    xhr.send(JSON.stringify(fileName));
  }
  async devDownloadFile(fileName,cbck) {
    var xhr = new XMLHttpRequest();
    var reponse = "";
    var url = this.dev_project_config + '/download';
    xhr.open('POST', url, true);
    // xhr.responseType ='blob'
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onload = function (e) {
      reponse = xhr.responseText;
      cbck(reponse);
    };
    xhr.onreadystatechange = function (aEvt) {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
        }
      }
    };
    xhr.send(JSON.stringify(fileName));
  }
  getPriceListMaster(){
    let obj = {"start":1,"end":1000,"userid":"1","rptname":"Pricelist_Master_12148","client":"starport1294"}
    let objData = {data : JSON.stringify(obj)}
    this.getContractList(objData).subscribe((respdata: any) => {
      if (respdata["_POST_SummaryMethodResult"].length > 0) {
        if (respdata["_POST_SummaryMethodResult"] !== "FAIL") {
          this.pricelistMaster = JSON.parse(respdata["_POST_SummaryMethodResult"]);
          if(this.pricelistMaster[0].versions == 'New-Pricelist'){
            this.pricelistService.priceList = JSON.parse(this.pricelistMaster[1].jsonData);
            this.pricelistService.pricelistID = this.pricelistMaster[1].Pricelist_Master_1_Id;
            this.pricelistService.pricelistVersionName = this.pricelistMaster[1].versions;
          }else{
            this.pricelistService.priceList = JSON.parse(this.pricelistMaster[0].jsonData);
            this.pricelistService.pricelistID = this.pricelistMaster[0].Pricelist_Master_1_Id;
            this.pricelistService.pricelistVersionName = this.pricelistMaster[0].versions;
          }
          this.pricelistService.pricelistCalculation();
        } 
      }
    });
  }
  getMsaMaster(){
    let obj = {"start":1,"end":1000,"userid":"1","rptname":"Msa_Masters_12553","client":"starport1294"}
    let objData = {data : JSON.stringify(obj)}
    this.getContractList(objData).subscribe((respdata: any) => {
      if (respdata["_POST_SummaryMethodResult"].length > 0) {
        if (respdata["_POST_SummaryMethodResult"] !== "FAIL") {
          let msaData: any = JSON.parse(respdata["_POST_SummaryMethodResult"]);
          this.msaMaster = msaData.reverse();
          this.msaId = this.msaMaster[this.msaMaster.length - 1].uniqueId;
          this.msaVersion = this.msaMaster[this.msaMaster.length - 1].versions;
        } 
      }
    });
  }
  getSowMaster(){
    let obj = {"start":1,"end":1000,"userid":"1","rptname":"Sow_Masters_12556","client":"starport1294"}
    let objData = {data : JSON.stringify(obj)}
    this.getContractList(objData).subscribe((respdata: any) => {
      if (respdata["_POST_SummaryMethodResult"].length > 0) {
        if (respdata["_POST_SummaryMethodResult"] !== "FAIL") {
          let sowData: any = JSON.parse(respdata["_POST_SummaryMethodResult"]);
          this.sowMaster = sowData.reverse();
          this.sowId = this.sowMaster[this.sowMaster.length - 1].uniqueId;
          this.sowVersion = this.sowMaster[this.sowMaster.length - 1].versions;
        } 
      }
    });
  }
  getSowListMaster(){
    let obj = {"start":1,"end":1000,"userid":"1","rptname":"Sow_List_12566","client":"starport1294"}
    let objData = {data : JSON.stringify(obj)}
    this.getContractList(objData).subscribe((respdata: any) => {
      if (respdata["_POST_SummaryMethodResult"].length > 0) {
        if (respdata["_POST_SummaryMethodResult"] !== "FAIL") {
            this.sowListMaster = JSON.parse(respdata["_POST_SummaryMethodResult"]);
        } 
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/providers/config-api-service/config-api-service.ts